import React from "react";

const PhotoGalleryModal = ({ modal }) => {
  console.log(modal);
  const { title, data, img } = modal;
  return (
    <>
      <input type="checkbox" id="my-modal-3" className="modal-toggle" />
      <label htmlFor="my-modal-3" className="modal cursor-pointer ">
        <label className="modal-box relative " htmlFor="my-modal-3 ">
          <h3 className="text-lg font-bold">{title}</h3>
          <p className="py-4">{data}</p>
          {img?.map((imgData, i) => (
            <img src={imgData} alt="" key={i} className="m-2" />
          ))}
        </label>
      </label>
    </>
  );
};

export default PhotoGalleryModal;
